import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Col,
    Form,
    Input,
    InputNumber,
    notification,
    Radio,
    Row,
    Table,
    Tag,
    Tooltip
} from "antd";
import { useEffect, useState } from "react";
import {
    addAndroidTemplatePassword,
    addTemplatePassword,
    deleteAndroidTemplatePassword,
    deleteTemplatePassword,
    getAndroidTemplatePassword,
    getTemplatePassword
} from "../../../axios/api.device";
import { gaEvent } from "../../../withTracker";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    brand:any,
    updateTemplate: () => void,
}

export const TemplateContentPassword = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate,brand} = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo();
    }, [])
    const getDataInfo = () => {
        console.log("templateTab",brand)
        if (platform == "Android") {
            getAndroidTemplatePassword(templateId).then((res) => {
                if (res && res != null) {
                    setShowTable(2)
                    res.autoLockTime = res.autoLockTime == -1 ? null: res.autoLockTime;
                    res.maxFailedAttempts = res.maxFailedAttempts == -1 ? null: res.maxFailedAttempts;
                    res.maxIdleTime = res.maxIdleTime  == -1 ? null: res.maxIdleTime;
                    res.validDays = res.validDays == -1 ? null: res.validDays;
                    dataForm?.setFieldsValue(res);
                } else {
                    setShowTable(1)
                }

            })
        } else {
            getTemplatePassword(templateId).then((res) => {
                if (res && res != null) {
                    setShowTable(2)
                    res.autoLockTime = res.autoLockTime == -1 ? null: res.autoLockTime;
                    res.maxFailedAttempts = res.maxFailedAttempts == -1 ? null: res.maxFailedAttempts;
                    res.maxIdleTime = res.maxIdleTime  == -1 ? null: res.maxIdleTime;
                    res.minLength = res.minLength == -1 ? null: res.minLength;
                    res.minSpecialLength = res.minSpecialLength == -1 ? null: res.minSpecialLength;
                    res.validDays = res.validDays == -1 ? null: res.validDays;
                    dataForm?.setFieldsValue(res);
                } else {
                    setShowTable(1)
                }

            })
        }

    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log(res)
                res.autoLockTime = res.autoLockTime ?? -1;
                res.maxFailedAttempts = res.maxFailedAttempts ?? -1;
                res.maxIdleTime = res.maxIdleTime ?? -1;
                res.minLength = res.minLength ?? -1;
                res.minSpecialLength = res.minSpecialLength ?? -1;
                res.validDays = res.validDays ?? -1;
                if (platform == "Android") {
                    addAndroidTemplatePassword(templateId, res).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                } else {
                    addTemplatePassword(templateId, res).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                }

            })
    }
    const deleteTemplateClick = () => {
        if (platform == "Android") {
            deleteAndroidTemplatePassword(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        } else {
            deleteTemplatePassword(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        }

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("密码")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置密码规则")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentPassword", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "90%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            labelCol={{ span: 20 }}
                            initialValues={{ isAllowSimple: true, isContainNumberAndLetter: true }}
                        >
                            {/* <Row>
                                <Col span={12}>
                                    <Item label="是否要求密码" name="isForcePin" rules={[{ required: true }]}>
                                        <Radio.Group >
                                            <Radio value={true}>是</Radio>
                                            <Radio value={false}>否</Radio>
                                        </Radio.Group>
                                    </Item>
                                </Col>
                                <Col span={12} >
                                    <p style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;是否强制要求设定密码</p>
                                </Col>
                            </Row> */}

                            <Item label={t("允许简单密码")} name="isAllowSimple" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("比如连续或相同数字、字母")}</>}>
                                <Radio.Group >
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>

                            {brand != "HONOR" && (
                            <Item label={t("包含数字字母")} name="isContainNumberAndLetter" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("需要包含数字和字母")}</>}>
                                <Radio.Group >
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>
                            )}

                            {platform != "Android" && (


                                <Item label={t("最短密码长度")} name="minLength" extra={<><InfoCircleOutlined /> {t("密码的最短长度、最长不超过24")}</>}>
                                    <InputNumber style={{ width: "100%" }} max="24" min="4" ></InputNumber>
                                </Item>

                            )}
                            {platform != "Android" && (

                                <Item label={t("最少特殊字符")} name="minSpecialLength" extra={<><InfoCircleOutlined /> {t("特殊字符包括!@$%等,最长不超过4个")}</>}>
                                    <InputNumber style={{ width: "100%" }} max="4"></InputNumber>
                                </Item>


                            )}

                            <Item label={t("密码有效天数")} name="validDays" extra={<><InfoCircleOutlined /> {t("新密码的有效天数,包括无,1到730天")}</>}>
                                <InputNumber addonAfter={t("天")} style={{ width: "100%" }} min="1" max="730" ></InputNumber>
                            </Item>
                            {brand != "HONOR" && (
                            <Item label={t("自动锁屏时间")} name="autoLockTime" extra={<><InfoCircleOutlined /> {t("一段时间不使用就会锁屏,需要重新输入密码,包括无,1到5分钟")}</>}>
                                <InputNumber addonAfter={t("分钟")} style={{ width: "100%" }} min="1" max="5" ></InputNumber>
                            </Item>
                            )}
 {brand != "HONOR" && (
                            <Item label={t("最大宽限期")} name="maxIdleTime" extra={<><InfoCircleOutlined /> {t("一段时间可以不输入密码,包括0到4小时")}</>}>
                                <InputNumber addonAfter={t("小时")} style={{ width: "100%" }} min="0" max="4" ></InputNumber>
                            </Item>
 )}
  {brand != "HONOR" && (
                            <Item label={t("密码失败次数")} name="maxFailedAttempts" extra="">
                                <InputNumber style={{ width: "100%" }} min="1"></InputNumber>
                            </Item>
  )}
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentPassword", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentPassword", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>

    </>)
};